<template>
    <div>
        <b-form @submit.prevent="saveSettings">
            <div v-if="group.type_id == 4 && settings.import_type == 1">
                <h5>Magazine</h5>
                <table class="table">
                    <tr>
                        <td style="width: 20%">
                            {{ $t('group.import.copy_of_magazine') }}
                        </td>
                        <td>
                            <b-form-input
                                v-model="settings.magazine_id"
                                type="number"
                                @input="checkMagazineId"></b-form-input>
                        </td>
                        <td>
                            <p
                                v-if="invalid_magazine_id"
                                style="color: red">
                                {{ $t('group.import.selected_id_is_not_a_valid_magazine') }}
                            </p>
                            <img
                                v-else
                                :src="magazine_cover"
                                style="border: 1px solid #000; border-radius: 0; width: 150px; height: auto" />
                        </td>
                    </tr>
                </table>
            </div>

            <div v-if="group.type_id == 4 && settings.import_type == 1">
                <table class="table">
                    <tr v-if="invalid_magazine_id">
                        <td style="width: 20%">{{ $t('group.import.page_size') }}</td>
                        <td>
                            <b-form-select
                                class="mb-3"
                                v-model="settings.magazine_page_size"
                                required>
                                <option
                                    v-for="size in pagesizes"
                                    :value="size.id">
                                    {{ size.title }} {{ size.width }}mm x {{ size.height }}mm
                                </option>
                            </b-form-select>
                        </td>
                    </tr>
                    <tr v-if="invalid_magazine_id">
                        <td style="width: 20%">{{ $t('group.import.number_of_pages') }}</td>
                        <td>
                            <b-form-input
                                v-model="settings.magazine_num_pages"
                                type="number"
                                required></b-form-input>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 20%">{{ $t('group.import.role_editor') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.magazine_editor_role"
                                required
                                :options="editor_roles"></b-form-select>
                        </td>
                    </tr>
                    <tr v-if="settings.magazine_editor_role == 2">
                        <td style="width: 20%">{{ $t('group.import.page_rights') }}</td>
                        <td>
                            <b-form-input
                                v-model="settings.magazine_page_rights"
                                type="text"
                                required></b-form-input>
                            <p style="padding-top: 5px">
                                {{
                                    $t(
                                        'group.import.indicate_comma_seperated_page_numbers_that_the_editor_has_access_to_eg_2_6_8_9',
                                    )
                                }}
                            </p>
                        </td>
                    </tr>
                </table>
            </div>

            <div v-if="group.type_id == 4 && !invalid_magazine_id && settings.import_type == 1">
                <h5>{{ $t('group.import.fill_in_automatically') }}</h5>
                <p>
                    {{
                        $t(
                            'group.import.indicate_on_which_page_and_which_element_should_be_filled_in_automatically_the_title_of_the_element_must_be_exactly_as_it_appears_in_the_editor_including_any_spaces_etc_after_it',
                        )
                    }}
                </p>
                <p>
                    {{
                        $t(
                            'group.import.the_text_to_be_filled_in_can_be_filled_in_with_text_from_the_excel_list_and_possibly_supplemented_with_your_own_text_for_example_in_the_case_that_you_want_to_put_the_date_of_birth_and_place_of_birth_seperated_by_comma_or_when_the_term_birthplace_should_come_before_the_place_itself',
                        )
                    }}
                </p>

                <div
                    v-for="block in settings.pageblocks"
                    style="border: 1px solid #ccc; display: block; margin-bottom: 10px; padding-bottom: 10px">
                    <table class="table">
                        <tr>
                            <td>
                                {{ $t('group.import.page') }}:
                                <b-form-input
                                    v-model="block.page"
                                    type="number"
                                    required></b-form-input>
                            </td>
                            <td>
                                {{ $t('common.title') }}:
                                <b-form-input
                                    v-model="block.title"
                                    type="text"
                                    required></b-form-input>
                            </td>
                        </tr>
                    </table>

                    <table class="table">
                        <tr>
                            <td>{{ $t('group.import.text_to_be_filled_in') }}:</td>
                        </tr>
                    </table>

                    <table class="table">
                        <tr v-for="(item, index) in block.items">
                            <td v-if="item.type_id == 1">
                                <b-form-select
                                    v-model="item.column"
                                    :options="headings"></b-form-select>
                            </td>
                            <td v-if="item.type_id == 2">
                                <b-form-input
                                    v-model="item.text"
                                    type="text"></b-form-input>
                            </td>
                            <td>
                                <button
                                    class="btn btn-inverse-danger"
                                    type="button"
                                    @click="deleteBlockItem(block, index)">
                                    <i class="fa fa-trash-alt"></i>
                                </button>
                            </td>
                        </tr>
                    </table>

                    <button
                        class="btn btn-primary float-right"
                        type="button"
                        @click="addBlockItem(block, 2)"
                        style="margin-right: 0.9375rem">
                        <i class="fa fa-plus"></i>
                        {{ $t('group.import.own_text') }}
                    </button>

                    <button
                        class="btn btn-primary float-right"
                        type="button"
                        @click="addBlockItem(block, 1)"
                        style="margin-right: 0.9375rem">
                        <i class="fa fa-plus"></i>
                        {{ $t('group.import.excel_column') }}
                    </button>

                    <div style="clear: both"></div>
                </div>

                <button
                    class="btn btn-primary float-right"
                    @click="addPageBlock">
                    {{ $t('group.import.new_text_block_to_be_filled') }}
                </button>

                <div style="clear: both"></div>
            </div>

            <div
                v-if="settings.import_type == 1 || settings.import_type == 2"
                style="margin-top: 20px">
                <h5>{{ $t('group.import.general') }}</h5>
                <table class="table">
                    <tr v-if="settings.import_type == 1">
                        <td style="width: 20%">{{ $t('group.import.move_existing_projects') }}</td>
                        <td>
                            <b-form-checkbox
                                v-model="settings.move_existing"
                                switch>
                                {{ $t('group.import.move_existing') }}
                            </b-form-checkbox>
                            <p style="padding-top: 5px">
                                {{
                                    $t(
                                        'group.import.if_a_student_is_found_by_mail_who_already_has_a_project_in_this_or_one_of_the_sub_main_groups_he_will_be_moved_to_this_group_instead_of_created',
                                    )
                                }}
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 20%">{{ $t('group.import.group_number') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.project_number"
                                required
                                :options="headings"></b-form-select>
                            <p style="padding-top: 5px">
                                {{
                                    $t(
                                        'group.import.if_there_are_no_groups_choose_another_unique_column_such_as_the_email_address_of_the_student',
                                    )
                                }}
                            </p>
                        </td>
                    </tr>
                    <tr v-if="settings.import_type == 1">
                        <td>{{ $t('common.title') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.project_title"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                </table>
            </div>

            <div style="margin-top: 20px">
                <h5>Leerling</h5>
                <table class="table">
                    <tr>
                        <td style="width: 20%">Volledige naam</td>
                        <td>
                            <b-form-select
                                v-model="settings.student_full_name"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('common.first_name') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.student_first_name"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('group.import.prefix') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.student_preposition"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('common.last_name') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.student_last_name"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('common.email_address') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.student_email"
                                required
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('group.import.number') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.student_number"
                                :options="headings"></b-form-select>
                            <p style="padding-top: 5px">
                                {{ $t('group.import.for_example_the_student_number_or_som_or_magister_number') }}
                            </p>
                        </td>
                    </tr>
                    <tr v-if="group.type_id == 4 && settings.import_type == 1">
                        <td>{{ $t('group.import.page_numbers') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.student_pagenumbers"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                </table>
            </div>

            <div style="margin-top: 20px">
                <h5>Docent</h5>
                <table class="table">
                    <tr>
                        <td style="width: 20%">{{ $t('group.import.full_name') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.teacher_full_name"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('common.first_name') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.teacher_first_name"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('group.import.prefix') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.teacher_preposition"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('common.last_name') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.teacher_last_name"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('common.email_address') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.teacher_email"
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                    <tr v-if="settings.import_type == 2">
                        <td>{{ $t('group.import.maximum_amount_of_groups') }}</td>
                        <td>
                            <b-form-select
                                v-model="settings.teacher_max"
                                required
                                :options="headings"></b-form-select>
                        </td>
                    </tr>
                </table>
            </div>

            <button
                class="btn btn-primary float-left"
                type="button"
                @click="goBack">
                {{ $t('common.previous') }}
            </button>

            <b-button
                class="float-right"
                type="submit"
                variant="primary"
                >{{ $t('common.next') }}
            </b-button>
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'GroupImportComponent',
    props: ['settingsIn', 'group', 'headingsIn', 'pagesizes'],
    data() {
        var headings = [];
        headings.push({ value: null, text: this.$t('group.import.make_a_choice') });
        for (const [key, value] of Object.entries(this.headingsIn)) {
            headings.push({ value: key, text: value });
        }

        return {
            headings: headings,
            settings: {
                project_number: this.settingsIn.project_number,
                project_title: this.settingsIn.project_title,
                student_full_name: this.settingsIn.student_full_name,
                student_first_name: this.settingsIn.student_first_name,
                student_preposition: this.settingsIn.student_preposition,
                student_last_name: this.settingsIn.student_last_name,
                student_email: this.settingsIn.student_email,
                student_pagenumbers: this.settingsIn.student_pagenumbers,
                student_number: this.settingsIn.student_number,
                teacher_full_name: this.settingsIn.teacher_full_name,
                teacher_first_name: this.settingsIn.teacher_first_name,
                teacher_preposition: this.settingsIn.teacher_preposition,
                teacher_last_name: this.settingsIn.teacher_last_name,
                teacher_email: this.settingsIn.teacher_email,
                magazine_id: this.settingsIn.magazine_id,
                pageblocks: this.settingsIn.pageblocks,
                magazine_editor_role: this.settingsIn.magazine_editor_role,
                magazine_page_size: this.settingsIn.magazine_page_size,
                magazine_page_rights: this.settingsIn.magazine_page_rights,
                import_type: this.settingsIn.import_type,
                teacher_max: this.settingsIn.teacher_max,
                move_existing: !!this.settingsIn.move_existing,
            },
            invalid_magazine_id: true,
            magazine_cover: null,
            editor_roles: [
                { value: 2, text: this.$t('group.import.editor') },
                { value: 1, text: this.$t('group.import.main_editor') },
            ],
        };
    },
    mounted() {
        if (this.settings.magazine_id != null && this.settings.magazine_id != '') {
            this.checkMagazineId(this.settings.magazine_id);
        }
    },
    methods: {
        addBlockItem(block, type_id) {
            block.items.push({ type_id: type_id, text: null, column: null });
        },
        deleteBlockItem(block, index) {
            block.items.splice(index, 1);
        },
        addPageBlock() {
            this.settings.pageblocks.push({ page: null, title: null, items: [] });
        },
        deletePageBlock() {},
        checkMagazineId(value) {
            if (value == '' || value == null) {
                this.invalid_magazine_id = true;
                this.magazine_cover = null;

                return;
            }

            let uri = '/group/' + this.group.id + '/import/' + this.settingsIn.id + '/checkvalidmagazine/' + value;

            axios
                .get(uri)
                .then((response) => {
                    if (response.data.valid) {
                        this.magazine_cover = response.data.cover;
                        this.invalid_magazine_id = false;
                    } else {
                        this.invalid_magazine_id = true;
                        this.magazine_cover = null;
                    }
                })
                .catch((error) => {
                    this.alert.ajaxError(error);
                });
        },
        saveSettings() {
            //check content

            this.alert.saving();

            let uri = '/group/' + this.group.id + '/import/' + this.settingsIn.id + '/settings';

            axios.post(uri, this.settings).then(
                (response) => {
                    window.location.href =
                        this.routes.baseUrl() +
                        '/group/' +
                        this.group.id +
                        '/import/' +
                        this.settingsIn.id +
                        '/validate';
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        goBack() {
            window.location.href =
                this.routes.baseUrl() + '/group/' + this.group.id + '/import/' + this.settingsIn.id + '/type';
        },
    },
};
</script>

<style scoped></style>
